var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00024 2V0H15.0002V2H20.0002V4H18.0002V19C18.0002 19.2652 17.8949 19.5196 17.7074 19.7071C17.5198 19.8946 17.2655 20 17.0002 20H3.00024C2.73503 20 2.48067 19.8946 2.29314 19.7071C2.1056 19.5196 2.00024 19.2652 2.00024 19V4H0.000244141V2H5.00024ZM4.00024 4V18H16.0002V4H4.00024ZM7.00024 7H9.00024V15H7.00024V7ZM11.0002 7H13.0002V15H11.0002V7Z",
    fill: "#363853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.8bc739fded076a9ed0b295a03a5e9357.svg";
export { ForwardRef as ReactComponent };